import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from "@azure/msal-angular";
import { SilentRequest } from "@azure/msal-browser";

import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MSGraphService {

    private _onAccessTokenChanged: BehaviorSubject<string>;

    /**
     * Constructor
     * @param {HttpClient} _http 
     * @param {MsalService} _msalService 
     * @param {MsalGuardConfiguration} msalGuardConfig 
     */
    constructor(private _http: HttpClient,
        private _msalService: MsalService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration){
        this._onAccessTokenChanged = new BehaviorSubject(
            localStorage.getItem("userToken")
        );
    }

    get onAccessTokenChanged(): Observable<any> {
        return this._onAccessTokenChanged.asObservable();
    }

    get accessToken(): string{
        return this._onAccessTokenChanged.value;
    }

    /**
     * Registrar el token para microsoft graph
     */
    register(): void{
        // Obtiene el access token para power bi
        this.getAccessToken()
        .then(resp => {
            localStorage.setItem('userToken', resp);
            this._onAccessTokenChanged.next(resp);
        })
        .catch(error => console.error(error));
    }

    /**
     * Obtiene la foto de perfil del usuario por medio del api de graph
     * @returns {Observable<Blob>} Devuelve la foto de perfil de Microsoft 365
     */
    getPhoto(): Observable<Blob>{

        const endpoint = `https://graph.microsoft.com/v1.0/me/photo/$value`;

        // Crea el encapezado de la petición
        const headers = {
            'Authorization' : `Bearer ${this.accessToken}`,
            'Content-type': 'image/jpeg'
        };

        // Realiza la llamada al api
        return this._http.get(endpoint,{ responseType: 'blob', headers: headers});
    }

    /**
     * Obtiene la foto de perfil del usuario por medio del api de graph
     * @param {string} userId Indica el id del usuario de Microsoft 365
     * @returns 
     */
    getPhotoByUserId(userId: string): Observable<Blob>{

        const endpoint = `https://graph.microsoft.com/v1.0/users/${userId}/photo/$value`;

        // Crea el encapezado de la petición
        const headers = {
            'Authorization' : `Bearer ${this.accessToken}`,
            'Content-type': 'image/jpeg'
        };

        // Realiza la llamada al api
        return this._http.get(endpoint,{ responseType: 'blob', headers: headers});
    }

    /**
     * Obtiene el access token para power bi
     * @returns {Promise<string>} Devuelve el access token de power bi
     */
    private async getAccessToken(): Promise<string> {
        const siletRequest = {...this.msalGuardConfig.authRequest, forceRefresh: true} as SilentRequest;
        siletRequest.scopes = ['https://graph.microsoft.com/.default'];

        const result = await this._msalService.acquireTokenSilent(siletRequest).toPromise();

        return result.accessToken;
    }

}
